import { AnswerSelectContainerProps } from '../config';
import { FC } from 'react';
import { IAnswerModel } from '../../../../state/stores/Question/AnswerModel';
import { SnapshotOrInstance } from 'mobx-state-tree';
import { observer } from 'mobx-react';
import { useInitChoiceWithFirstAnswer } from '../useInitChoiceWithFirstAnswer';
import { useStores } from '../../../../hooks/useStores';

const _ContainAssistanceMode: FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
}) => {
  const { question: qstore } = useStores();
  const loading = !qstore.isReady(question._id);
  const answers = question.answers || [];
  const isSingleOption = answers.length === 1;

  // When the service supports only one appointment mode (e.g. phone-only for
  // Practical Support), auto-select it so the user can't leave it unselected.
  useInitChoiceWithFirstAnswer({
    answers: isSingleOption ? answers as NonNullable<typeof question.answers> : [],
    questionId: question._id,
    questionKey: question.key,
  });

  const onPressAssistanceMode = (answer: SnapshotOrInstance<IAnswerModel>) => {
    // Single-option case: the answer is already pending. Treating taps on it
    // as a no-op (still forwarding to onPress so auto-advance works) keeps the
    // checkmark stable — there's nothing meaningful to re-select.
    onPress(answer);
  };

  return children({
    answers: question.answers,
    questionId: question._id,
    questionKey: question.key,
    onPress: onPressAssistanceMode,
    loading,
  });
};

export const ContainAssistanceMode = observer(_ContainAssistanceMode);
